import React from 'react';
import { connect } from 'react-redux';

import LazyScrollMetricTracker from 'src/universal/components/DTM/LazyScrollMetricTracker';

import {
  makeGetOfferMetaData,
  makeGetDualOfferContentExists,
  makeGetIsPznOffer,
  makeGetIsSpecialOffer
} from '../redux';

import { cmComponentPznExt } from 'src/universal/utils/orchestraCmPznExtEvent';
import { sendDTMCustomEvent } from 'service_modules/models/dtm-tagging';

const TrackScroll = ({
  isPznOffer,
  offerMetaData,
  shortName,
  dualOfferContentExists,
  isSpecialOffer
}) => {
  const sendScrollReachEvent = () =>
    sendDTMCustomEvent({
      eventAction: 'impression',
      eventAsset: `${
        dualOfferContentExists ? 'DualOffer-' : ''
      }Scroll-Reach-${shortName}`,
      eventType: 'pageInteraction'
    });

  const cmPznExt = () => {
    if (offerMetaData) {
      cmComponentPznExt(offerMetaData);
    }
  };

  const sendOfferReachEvent = () => {
    if (isPznOffer) {
      sendDTMCustomEvent({
        eventAction: 'impression',
        eventAsset: `pzn_offer${isSpecialOffer ? '-special' : ''}_${shortName}`,
        eventType: 'pageInteraction'
      });
    }
  };

  const callbackFunction = () => {
    sendScrollReachEvent();
    sendOfferReachEvent();
    cmPznExt();
  };
  return <LazyScrollMetricTracker callBackFunction={callbackFunction} />;
};

const mapStateToProps = () => {
  const getOfferMetaData = makeGetOfferMetaData();
  const getDualOfferContentExists = makeGetDualOfferContentExists();
  const getIsPznOffer = makeGetIsPznOffer();
  const getIsSpecialOffer = makeGetIsSpecialOffer();

  return (state, { shortName }) => ({
    offerMetaData: getOfferMetaData(state, shortName),
    dualOfferContentExists: getDualOfferContentExists(state, shortName),
    isPznOffer: getIsPznOffer(state, shortName),
    isSpecialOffer: getIsSpecialOffer(state, shortName)
  });
};

export default connect(mapStateToProps)(TrackScroll);
